import { render } from "./AddressTiles.vue?vue&type=template&id=c9254d4c"
import script from "./AddressTiles.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressTiles.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/checkout/AddressTiles.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c9254d4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c9254d4c', __exports__)) {
    api.reload('c9254d4c', __exports__)
  }
  
  module.hot.accept("./AddressTiles.vue?vue&type=template&id=c9254d4c", () => {
    api.rerender('c9254d4c', render)
  })

}


export default __exports__